import React, { Component } from "react";
import { recruiterProfileDetails } from "../../action/profile";
import constant from "../../constant";
import AsideRightMenu from "../Dashboard/AsideRightMenu";
import Loader from "../Common/Loader";
// import logo from './../../assets/images/logo.png'
import { getProfileImage } from "../../utils";
import Shimmer from "../../old_Components/Common/Shimmer";
import { Link } from "react-router-dom";
import khaliimage from "../../assets/images/Default-company-logo (3).png";
// import swal from "sweetalert";
import { updateCompanyPicture } from "../../action/profile";

export default class ViewProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: undefined,
      showLoader: false,
      profileImage: null,
      showShimmer: false,
    };
  }
  onPictureUpload = (e) => {

    debugger
    let file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    updateCompanyPicture(formData).then((res) => {
      if (res.status) {
        console.log("SUCCESS");
        window.location.reload();
        //    onChange(this, res.result.fileName);
      } else {
        alert(res.error);
      }
    });
  };

  componentDidMount() {
    document.title = constant.title.ViewProfile;
    this.setState({ showLoader: true });
    recruiterProfileDetails().then((res) => {
      if (res.status) {
        this.setState({ showLoader: false });
        this.setState({ details: res.result });
      }
    });
    this.setState({ showShimmer: true });
    getProfileImage().then((res) => {
      if (res.status) {
        this.setState({ showShimmer: false });
        this.setState({ profileImage: res.result.fileName });
      }
    });
  }

  render() {
    const { details, profileImage, showLoader, showShimmer } = this.state;
    return (
      <React.Fragment>
        {showLoader && <Loader />}
        <section className="profile-sec-bx pricing-area padding-top-100px padding-bottom-80px">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <AsideRightMenu />
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="breadcrumb-content d-flex flex-wrap justify-content-between align-items-center">
                      <ul className="list-items d-flex align-items-center">
                        <li className="active__list-item">
                          <Link
                            to={constant.component.Dashboard.url}
                            className="text-secondary"
                          >
                            Home
                          </Link>
                        </li>
                        <li className="active__list-item text-secondary">
                          <Link
                            to={constant.component.Dashboard.url}
                            className="text-secondary"
                          >
                            Dashboard
                          </Link>
                        </li>
                        <li className=" text-secondary">View Profile</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="billing-form-item mb-0">
                      <div
                        className="billing-title-wrap"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <h3 className="widget-title pb-0">View Profile</h3>
                          <div className="title-shape margin-top-5px"></div>
                        </div>
                        <div>
                          <h3 className="widget-title pb-0">
                            <a
                              class="theme-btn border-0 line-height-35"
                              href={constant.component.EditProfile.url}
                            >
                              Edit Profile
                            </a>
                          </h3>
                        </div>
                      </div>

                      {showShimmer && <Shimmer />}
                      <div
                        className="billing-content"
                        style={{ paddingBottom: "10px" }}
                      >
                        {details && (
                          <div className="postjob-form-action">
                            <div
                              className="pro-img-bx"
                              style={{
                                width: "15%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                border: "1px solid lightgrey",
                              }}
                            >
                              {
                                details.COMPANY_LOGO ? (
                                  <img
                                    src={
                                      profileImage
                                        ? `${process.env.REACT_APP_BASE_URL}/company/logo/${profileImage}`
                                        : ""
                                    }
                                    alt="company logo"
                                    style={{
                                      width: "120px",
                                      height: "auto",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <div>
                                    <label for="file-input">
                                      <img
                                        src={khaliimage}
                                        alt='Upload New Logo'
                                        style={{
                                          width: "120px",
                                          height: "auto",
                                          objectFit: "contain",
                                          marginTop: "10px",
                                        }}
                                      />
                                    </label>
                                    <input
                                      type="file"
                                      onChange={(e) => this.onPictureUpload(e)}
                                      id="file-input"
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                )

                                // <h6 style={{ fontSize: "30px", margin: "20px" }}>{details.COMPANY_NAME.split(' ').length === 1 ? details.COMPANY_NAME.slice(0, 1) : details.COMPANY_NAME.split(' ').map((i) => i.substring(0, 1)).join('').slice(0, 3)}</h6>
                              }
                            </div>
                          </div>
                        )}
                      </div>
                      {this.state.showLoader && <Loader />}
                      {details && (
                        <table className="view-profile-table table table-striped mb-0">
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Primary Email
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.EMAIL}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Secondary Email
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.SECONDARY_EMAIL
                                  ? details.SECONDARY_EMAIL
                                  : "NA"}
                              </td>
                            </tr>
                            {/* <tr>
                                                        <td style={{ width: "40%", paddingLeft:'28px' }}>Role</td>
                                                        <td style={{fontWeight:"300"}}>{details.EMPLOYER_ROLE_ID}</td>
                                                    </tr> */}
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Mobile
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.PHONE_CODE} {details.MOBILE}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "40%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Location
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.LOCATION ? details.LOCATION : "NA"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Company Name
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.COMPANY_NAME}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Company Category{" "}
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.EMPLOYER_CATEGORY}
                              </td>
                            </tr>
                            {/* <tr>
                                                        <td style={{ width: "40%", paddingLeft:'28px' }}>Company Type</td>
                                                        <td style={{fontWeight:"300"}}>{details.COMPANY_TYPE_ID}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ width: "40%", paddingLeft:'28px' }}>Industry Type</td>
                                                        <td style={{fontWeight:"300"}}>{details.EMPLOYER_INDUSTRY_ID}</td>
                                                    </tr> */}
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Contact Person
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.CONTACT_PERSON}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Pin Code
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.PINCODE}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Contact Person's Designation
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.CONTACT_PERSON_DESIGNATION}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Website URL
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.WEBSITE}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Phone 1
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.PHONE_1 ? details.PHONE_1 : "NA"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Phone 2
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.PHONE_2 ? details.PHONE_2 : "NA"}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                FAX Number
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.FAX_NUMBER ? details.FAX_NUMBER : "NA"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Company Logo
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.COMPANY_LOGO ? (
                                  <img
                                    src={
                                      profileImage
                                        ? `${process.env.REACT_APP_BASE_URL}/company/logo/${profileImage}`
                                        : ""
                                    }
                                    alt="company logo"
                                    style={{
                                      width: "120px",
                                      height: "auto",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <h6
                                    style={{ fontSize: "30px", margin: "20px" }}
                                  >
                                    {details.COMPANY_NAME.split(" ").length ===
                                      1
                                      ? details.COMPANY_NAME.slice(0, 1)
                                      : details.COMPANY_NAME.split(" ")
                                        .map((i) => i.substring(0, 1))
                                        .join("")
                                        .slice(0, 3)}
                                  </h6>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Company Header Background
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.COMPANY_HEADER_BACKGROUND ? (
                                  <img
                                    src={
                                      details.COMPANY_HEADER_BACKGROUND
                                        ? `${process.env.REACT_APP_BASE_URL}/company/header-background/${details.COMPANY_HEADER_BACKGROUND}`
                                        : ""
                                    }
                                    alt="company logo"
                                    style={{
                                      width: "120px",
                                      height: "auto",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <h6
                                    style={{ fontSize: "30px", margin: "20px" }}
                                  >
                                    {details.COMPANY_NAME.split(" ").length ===
                                      1
                                      ? details.COMPANY_NAME.slice(0, 1)
                                      : details.COMPANY_NAME.split(" ")
                                        .map((i) => i.substring(0, 1))
                                        .join("")
                                        .slice(0, 3)}
                                  </h6>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Facebook Page URL
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.FB_URL}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Linkedin Profile URL
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.LINKEDIN_URL}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Twitter URL
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.TWITTER_URL}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Company Size{" "}
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.COMPANY_SIZE}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Founded
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.FOUNDED}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                Headquarters
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.HEADQUARTERS}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  paddingLeft: "28px",
                                  fontWeight: "500",
                                }}
                              >
                                About Company
                              </td>
                              <td style={{ fontWeight: "300" }}>
                                {details.ABOUT_COMPANY}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
